import React from 'react';
import './DisposalToolCard.css';

export default function DisposalToolCard({ tool, onClick }) {
  const primaryPhoto = tool.photos && tool.photos.length > 0 ? tool.photos[0] : null;
  const photoCount = tool.photos ? tool.photos.length : 0;

  // The five location numbers render together when any one has a value, and
  // not at all when none does. Has-value test, so "0" renders as 0.
  const hasValue = v => v !== null && v !== undefined && v !== '';
  const nbr = v => (hasValue(v) ? String(v) : '—');
  const hasNbr = [tool.rowNbr, tool.stackNbr, tool.rackNbr, tool.shelfNbr, tool.skidNbr].some(hasValue);

  return (
    <div className="disposal-tool-card" onClick={onClick}>
      <div className="card-photo-section">
        {primaryPhoto ? (
          <>
            <img src={primaryPhoto} alt={tool.toolId} className="card-photo" />
            {photoCount > 1 && (
              <div className="photo-indicators">
                {Array.from({ length: Math.min(photoCount, 3) }).map((_, i) => (
                  <span
                    key={i}
                    className={`photo-dot ${i === 0 ? 'active' : ''}`}
                  />
                ))}
              </div>
            )}
          </>
        ) : (
          <div className="card-photo-placeholder">
            <span className="photo-icon">📷</span>
            <span>No photo</span>
          </div>
        )}
      </div>

      <div className="card-content">
        <div className="card-top">
          <div className="card-oem">{tool.oem || '—'}</div>

          <div className="card-tool-id">
            <strong>TOOL ID:</strong> {tool.toolId}
          </div>

          <div className="card-details">
            <div className="detail-row">
              <strong>Est Lbs:</strong> {tool.weight ? tool.weight.toLocaleString() : '—'}
            </div>
            <div className="detail-row">
              <strong>Est. Size:</strong> {tool.size || '—'}
            </div>
          </div>

          <div className="card-location">
            <div className="location-row primary-location">
              <strong>LOCATED:</strong> {tool.siteLoc || '—'}
            </div>
            <div className="location-row">
              <strong>DETAIL LOC:</strong> {tool.sectionDetail || '—'}
            </div>
            {hasNbr && (
              <>
                <div className="location-row">
                  <strong>ROW NBR:</strong> {nbr(tool.rowNbr)}
                </div>
                <div className="location-row">
                  <strong>STACK NBR:</strong> {nbr(tool.stackNbr)}
                </div>
                <div className="location-row">
                  <strong>RACK NBR:</strong> {nbr(tool.rackNbr)}
                </div>
                <div className="location-row">
                  <strong>SHELF NBR:</strong> {nbr(tool.shelfNbr)}
                </div>
                <div className="location-row">
                  <strong>SKID NBR:</strong> {nbr(tool.skidNbr)}
                </div>
              </>
            )}
          </div>
        </div>

        <div className="card-status">
          <button className={`status-badge ${(tool.marked || 'locate').toLowerCase()}`}>
            {tool.marked || 'LOCATE'}
          </button>
        </div>
      </div>
    </div>
  );
}
